"use client";
// РУКА 2. Кнопка «Комплект в корзину»: весь комплект одной строкой корзины.
import { useState } from "react";
import { addToCart } from "./cart";

export function AddKitButton({ slug }: { slug: string }) {
  const [added, setAdded] = useState(false);
  return (
    <button
      type="button"
      onClick={() => {
        addToCart({ kind: "kit", slug, qty: 1 });
        setAdded(true);
      }}
      className="w-full sm:w-auto bg-btn hover:bg-btn-h text-white font-semibold rounded-card px-5 py-3 transition-colors"
    >
      {added ? "Комплект в корзине" : "Комплект в корзину"}
    </button>
  );
}
